<template>
  <div
    :class="`modal fade show ${c.props?.class || ''}`"
    :style="{ display: 'block' }"
    v-if="isOpen"
  >
    <div
      class="modal-dialog"
      :class="classDialog"
    >
      <div class="modal-content">
        <div class="modal-header">
          <template v-if="c.props?.headerText">
            <div class="modal-title">{{ c.props.headerText }}</div>
          </template>
          <select
            v-if="c.props?.options"
            class="form-select form-select-sm ms-4 w-auto"
            @change="onSelectChange"
          >
            <option
              v-for="(opt, index) in c.props.options"
              :key="index"
              :value="opt.value"
            >
              {{ opt.label }}
            </option>
          </select>
          <button
            type="button"
            class="btn-close ms-auto"
            @click="() => onClose()"
          ></button>
        </div>
        <div
          class="modal-body"
          :class="classBody"
        >
          <component
            :is="c.component"
            v-bind="c.props"
            v-on="c.events"
            :ref="bindComponentRef"
          >
            Loading...
          </component>
        </div>
      </div>
    </div>
  </div>
  <Teleport to="body">
    <div
      class="modal-backdrop fade show"
      v-if="isOpen"
    ></div>
  </Teleport>
</template>

<script setup>
import { provide, ref, computed, watch } from 'vue'
import { useModalStack } from '@provise/stores/modalstack'
import { storeToRefs } from 'pinia'
import { useUiStore } from '@provise/stores/ui'
import { syncRef } from '@vueuse/core'

const modalStack = useModalStack()
const { stack } = storeToRefs(modalStack)
const { fullscreen } = storeToRefs(useUiStore())
const isOpen = ref(false)
const c = computed(() => stack.value[stack.value.length - 1])
const fs = ref(false)
const classDialog = computed(() => {
  const cl = {
    'fit-content': c.value.props?.fitContent,
    'modal-fullscreen': fs.value,
  }
  return cl
})
const classBody = computed(() => ({ 'px-1': fs.value }))

syncRef(fs, fullscreen, { direction: 'rtl' })

watch(stack, stack => (isOpen.value = stack.length > 0))
watch(isOpen, isOpen => {
  document.body.classList.toggle('modal-open', isOpen)
})

provide('modalstack', true)
provide('fullscreen', fs)

function onClose(data = null) {
  window.dispatchEvent(new CustomEvent('modalstack:close'))
  fs.value = fullscreen.value
  modalStack.pop(data)
}

function onSelectChange(e) {
  const value = e.target.value
  c.value?.props?.onSelect?.(value)
}

function bindComponentRef(el) {
  if (c.value?.componentRef) {
    c.value.componentRef.value = el
  }
}

</script>
